import { Gender } from "../../../api/auth/apiClient";

export const optionsDataGender = [
  {
    label: "Мужской",
    value: Gender.Male,
  },
  {
    label: "Женский",
    value: Gender.Female,
  },
];
